<template>
  <div class="main">
    <div class="costomize">
      <div class="content">
        <!-- 仅自己可创建 -->
        <el-button class="add_album" v-if="userid == owner_id && identity.identity_status == 1" @click="addBtn()">
          <i class="icon_add_album icon_small"></i>
          创建相册
        </el-button>
        <div v-if="isShow" class="noDataMask">当前教师没有相册</div>
        <div v-else class="itemWrap" v-loading="loading">
          <div class="item" v-for="item in albumData" :key="item.album_id">
            <div class="photo_cover">
              <el-image v-if="item.album_cover_resource_id == false" @click="toPhotoInfo(item)"
                style="width: 202px; height: 140px;cursor:pointer;" :src="photo_default" fit="cover"></el-image>
              <el-image v-else @click="toPhotoInfo(item)" style="width: 202px; height: 140px;cursor:pointer;"
                :src="item.album_cover_resource_id" fit="cover"></el-image>
              <div class="photo_option" v-if="userid == owner_id">
                <div>
                  <div class="arrow">
                    <i class="el-icon-arrow-down"></i>
                    <div class="op_wrap">
                      <div class="op_item" @click="editBtn(item)"
                        v-if="item.school_id == identity.school_id && identity.identity_status == 1">
                        <i class="el-icon-edit"></i>
                        <span class="op_text">编辑</span>
                      </div>
                      <div class="op_item" @click="delBtn(item)">
                        <i class="el-icon-delete"></i>
                        <span class="op_text">删除</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="photo_count">{{item.album_photo_num > 999 ? "999+" : item.album_photo_num}}张</div>
              <!-- 数量大于999显示999+ -->
            </div>
            <div class="photo_title">{{item.album_name}}</div>
            <div class="limit">
              <img src="../../assets/img/icon-file/publicity_jurisdiction_icon.png" alt />
              <span v-if="item.album_permission == 1 || item.album_permission == 0" class="line"
                :title="item.cn_album_permission">{{item.cn_album_permission}}</span>
              <span v-else class="line" :title="item.school_name+'内'">{{item.school_name}}内</span>
              <span class="time">{{item.create_time}}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination background layout="prev, pager, next" @current-change="PageChange" :current-page="this.page"
          :page-size="this.pageSize" :total="this.count" :hide-on-single-page="true"></el-pagination>
      </div>
      <!-- 创建相册弹出框 -->
      <el-dialog class="add_album_box" title="创建相册" :visible.sync="addAlbumVisible" width="460px">
        <div class="dialog_content">
          <div class="left_title">
            <div class="title_text">
              <span style="color:red;">*</span>
              <span>相册名称:</span>

              <!-- <i style="color:red">*</i> -->
            </div>
            <div class="title_text">相册描述:</div>
            <div class="title_text">
              <span style="color:red;">*</span>
              权限:
            </div>
          </div>
          <div class="right_input">
            <el-input class="input_item album_name" v-model.trim="album_name" placeholder="请输入相册名称" maxlength="20"
              show-word-limit></el-input>
            <el-input class="input_item album_description" type="textarea" :rows="2" placeholder="请输入相册描述"
              maxlength="200" show-word-limit v-model="album_description"></el-input>
            <el-select class="input_item album_select" v-model="album_permission" placeholder="请选择权限">
              <el-option v-for="item in album_permissionData" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" :disabled="isDisabled" @click="CreateAlbumBtnOk">确 定</el-button>
          <el-button @click="addAlbumVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 编辑相册弹出框 -->
      <el-dialog class="add_album_box" title="编辑相册" :visible.sync="editAlbumVisible" width="460px">
        <div class="dialog_content">
          <div class="left_title">
            <div class="title_text">
              <span style="color:red;">*</span>
              相册名称:
            </div>
            <div class="title_text">相册描述:</div>
            <div class="title_text">
              <span style="color:red;">*</span>
              权限:
            </div>
          </div>
          <div class="right_input">
            <el-input class="input_item album_name" v-model.trim="album_name" maxlength="20" show-word-limit
              placeholder="请输入相册名称"></el-input>
            <el-input class="input_item album_description" type="textarea" :rows="2" placeholder="请输入相册描述"
              v-model="album_description" maxlength="200" show-word-limit></el-input>
            <el-select class="input_item album_select" v-model="album_permission" placeholder="请选择权限">
              <el-option v-for="item in album_permissionData" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="editBtnOk">确 定</el-button>
          <el-button @click="editAlbumVisible = false">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 删除相册弹出框 -->
      <el-dialog class="del_album_box" title="提示" center :visible.sync="delAlbumVisible" width="350px"
        style="margin-top:20vh !important">
        <p style="text-align: center;">
          确定删除该相册，相册中有
          <span style="color:red">{{this.album_photo_num}}</span>&nbsp;张照片!
        </p>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="delBtnOk">确 定</el-button>
          <el-button @click="delAlbumVisible = false">取 消</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import globalApi from "@/common/globalApi.js";
import { log } from "util";
export default {
  name: "photo_album",
  data() {
    return {
      photo_default: require("../../assets/img/no_photo.png"), // 相册默认封面
      isShow: false,
      album_permissionData: [
        {
          value: "1",
          label: "公开",
        },
        {
          value: "4",
          label: "本校",
        },
        {
          value: "0",
          label: "不公开",
        },
      ],
      page: 1,
      pageSize: 25,
      count: 0,
      albumData: [], // 相册数据
      album_id: "", // 相册id
      album_name: "", // 相册名称
      album_description: "", // 相册描述
      album_permission: "", // 相册权限
      album_photo_num: "", // 相册中的相片
      addAlbumVisible: false,
      editAlbumVisible: false,
      delAlbumVisible: false,
      isDisabled: false, // 是否禁止创建
      userid: 1, // 登陆者用户
      role: "",
      identity: "",
      owner_id: 0,
      websiteSessionInfo: globalApi.gWebsiteSessionInfo,
      loading: false,
    };
  },
  computed: {
    globalVaranthasInited() {
      return globalApi.gWebsiteSessionInfo.hasInited;
    },
  },
  watch: {
    globalVaranthasInited: function () {
      this.init();
    },
  },
  created() {},

  methods: {
    init() {
      this.owner_id = this.$route.query.userid; // 教师空间id
      if (this.owner_id == undefined) {
        this.$router.push("error");
        return false;
      }
      this.GetAlbumList(); // 获取相册
      this.getLoginUserInfo(); // 获取登录信息
    },
    // 获取用的登录数据并存入localStorage
    async getLoginUserInfo() {
      const isLogin = this.websiteSessionInfo.logined;
      if (isLogin) {
        this.userid = this.websiteSessionInfo.userid;
        this.GetAuth(); // 获取权限
        this.GetIdentity(); // 获取身份
      }
    },

    // 分页导航
    PageChange(val) {
      this.page = val;
      document.documentElement.scrollTop = 0;
      this.GetAlbumList();
    },

    // 获取相册列表接口
    async GetAlbumList() {
      this.loading = true;
      const data = {
        s: "WebClassSpace.Photo.GetAlbumList",
        creator_id: this.owner_id,
        album_type: 3, // 类型-教师空间
        page: this.page,
        page_size: this.pageSize,
      };
      const res = await globalApi.post(data);
      this.loading = false;
      const response = res.data.data.result;
      if (res.data.ret != 200 || response != 1) {
        return false;
      }

      this.albumData = res.data.data.album_list;
      this.count = res.data.data.record_count;
      var page_count = res.data.data.page_count; // 最大页数
      this.count == 0 ? (this.isShow = true) : (this.isShow = false);
      if (this.page > page_count) {
        this.page = this.page - 1;
        this.GetAlbumList();
      }
    },

    // 创建相册接口
    async CreateAlbum() {
      const data = {
        s: "WebClassSpace.Photo.CreateAlbum",
        album_type: 3, // 类型-教师空间
        album_name: this.album_name, // 相册名称
        album_description: this.album_description, // 相册描述
        album_permission: this.album_permission, // 相册权限
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }
      if (response == 1) {
        this.addAlbumVisible = false;
        this.$message.success("相册创建成功!");
        this.GetAlbumList();
      } else {
        this.$message.error("相册创建失败!");
      }
    },

    // 修改相册信息
    async AlterAlbumInfo() {
      const data = {
        s: "WebClassSpace.Photo.AlterAlbumInfo",
        album_id: this.album_id, // 相册id
        album_name: this.album_name, // 相册名称
        album_description: this.album_description, // 相册描述
        album_permission: this.album_permission, // 相册权限
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }
      if (response == 1) {
        this.editAlbumVisible = false;
        this.$message.success("相册编辑成功!");
        this.GetAlbumList();
      } else {
        this.$message.error("相册编辑失败!");
      }
    },

    // 删除相册
    async DeleteAlbum() {
      const data = {
        s: "WebClassSpace.Photo.DeleteAlbum",
        album_id: this.album_id, // 相册id
      };

      const res = await globalApi.post(data);
      const response = res.data.data.result;
      if (res.data.ret != 200) {
        return false;
      }
      if (response == 1) {
        this.delAlbumVisible = false;
        this.$message.success("相册删除成功!");
        this.GetAlbumList();
      } else {
        this.$message.error("相册删除失败!");
      }
    },

    // 点击创建相册
    async addBtn() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.isDisabled = false;
      this.addAlbumVisible = true;
      this.album_name = ""; // 相册名称
      this.album_description = ""; // 相册描述
      this.album_permission = ""; // 相册权限
    },

    // 确认创建相册
    async CreateAlbumBtnOk() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      var fl = this.album_name.substring(0, 1); // 首个字母
      if (this.album_name == false && (fl != 0 || fl == "")) {
        this.$message.error("相册名称不能为空!");
        return false;
      }
      if (this.album_permission == "") {
        this.$message.error("请选择权限!");
        return false;
      }
      this.isDisabled = true;
      this.CreateAlbum();
    },

    // 点击编辑相册
    async editBtn(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.editAlbumVisible = true;
      this.album_id = val.album_id; // 相册id
      this.album_name = val.album_name; // 相册名称
      this.album_description = val.album_description; // 相册描述
      this.album_permission = String(val.album_permission); // 相册权限
    },

    // 确认编辑相册
    async editBtnOk() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      var fl = this.album_name.substring(0, 1); // 首个字母
      if (this.album_name == false && (fl != 0 || fl == "")) {
        this.$message.error("相册名称不能为空!");
        return false;
      }
      if (this.album_permission == "") {
        this.$message.error("请选择权限!");
        return false;
      }
      this.AlterAlbumInfo();
    },

    // 点击删除相册
    async delBtn(val) {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.delAlbumVisible = true;
      this.album_photo_num = val.album_photo_num; // 相册中的相片
      this.album_id = val.album_id;
    },

    // 确认删除相册
    async delBtnOk() {
      const is_login = await globalApi.CheckAndGotoLogin();
      if (!is_login) {
        return;
      }
      this.DeleteAlbum();
    },

    // 跳转相片列表
    // 获取权限
    async GetAuth() {
      const data = {
        s: "Common.Auth.getAuth",
        operator_id: this.userid, // 登陆者id
        user_id: this.owner_id, // 空间id
      };

      const res = await globalApi.post(data);
      if (res.data.ret != 200) {
        return false;
      }
      this.role = res.data.data;
    },

    // 跳转相片列表
    // 获取身份
    async GetIdentity() {
      const data = {
        s: "Common.Auth.getIdentity",
        user_id: this.userid, // 登陆者id
      };

      const res = await globalApi.post(data);
      this.identity = res.data.data;
    },

    // 权限 album_permission [0-不公开 1-公开 2-本班 4-本校 6-本市]
    async toPhotoInfo(val) {
      var owner_id = this.owner_id;
      var userid = this.userid;
      var album_permission = val.album_permission;
      if (album_permission != 1) {
        const is_login = await globalApi.CheckLoginUserStatus(this);
        if (!is_login) {
          this.$message.error("对不起,你没有查看该相册的权限!");
          return;
        }
      }
      if (
        album_permission == 1 ||
        (album_permission == 0 && owner_id == userid) ||
        (album_permission == 2 && this.role.isClass == true) ||
        (album_permission == 4 && this.role.isSchool == true) ||
        (album_permission == 6 && this.role.isCity == true)
      ) {
        this.$router.push({
          path: "/photo_info",
          query: { userid: this.owner_id, album_id: val.album_id },
        });
      } else if (userid == 1 && album_permission != 1) {
        let fromurl = encodeURIComponent(location.href);
        location.href = globalApi.GetWebHost("login") + '?fromurl=' + fromurl;
        return false;
      } else {
        this.$message.error("对不起,你没有查看该相册的权限!");
        return false;
      }
    },
  },
};
</script>
<style lang="scss">
@import "../../assets/scss/main.scss";
.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}

.el-select-dropdown__item {
  color: #333;
}
.el-pagination {
  text-align: center;
  margin: 20px 0;
}
</style>
<style lang="scss" scoped>
@import "../../assets/scss/index_body.scss";
@import "../../assets/scss/main.scss";
.main {
  width: 1200px;
  margin: 0 auto;
  font-size: 14px;
  color: #666666;

  .content {
    background: #fff;
    padding: 30px 20px;
    min-height: 580px;
    margin-top: 25px;
    .noDataMask {
      background: url("../../assets/img/Album_icon_Photo.png.png") no-repeat
        center;
      height: 580px;
      text-align: center;
      font-size: 14px;
      color: #666;
      line-height: 796px;
    }
    .add_album {
      border: 2px solid #0088ff;
      color: #0088ff;
      font-size: 14px;
    }
    .itemWrap {
      display: flex;
      flex-wrap: wrap;
      margin-top: 40px;
      .item:nth-child(5n) {
        margin: 0 0 30px 0;
      }
      .item {
        background: #eff2f3;
        box-sizing: border-box;
        width: 218px;
        margin: 0 15px 30px 0;
        padding: 8px;
        .photo_cover:hover {
          .arrow {
            display: block !important;
          }
        }
        .photo_cover {
          width: 202px;
          height: 140px;
          border-radius: 2px;
          margin-left: 0 !important;
          position: relative;
          img {
            width: 202px;
            height: 140px;
            border-radius: 2px;
            margin-left: 0 !important;
            cursor: pointer;
          }
          .photo_option {
            color: #08f;
            .el-icon-arrow-down:before {
              font-size: 16px;
              font-weight: bold;
            }
            .arrow:hover {
              .op_wrap {
                display: block;
              }
            }
            .arrow {
              cursor: pointer;
              position: absolute;
              top: 4px;
              right: 4px;
              border-radius: 2px;
              background: #fff;
              width: 24px;
              height: 24px;
              text-align: center;
              display: none;
              box-sizing: border-box;
              padding-top: 5px;
            }
            .op_wrap {
              position: absolute;
              top: 24px;
              right: 0px;
              display: none;
              border-radius: 4px;
              background: #fff;
              width: 100px;
              .op_item:hover {
                color: #fff;
                background: #08f;
                border-radius: 4px;
              }
              .op_item {
                text-align: center;
                padding: 9px 0;
              }
              .op_text {
                margin-left: 10px;
              }
            }
          }
          .photo_count {
            color: #fff;
            position: absolute;
            right: 10px;
            bottom: 0px;
            font-weight: bold;
            font-size: 18px;
            height: 28px;
            line-height: 1;
          }
        }
        .photo_title {
          @include no-wrap();
          margin: 16px 0 15px;
          font-size: 16px;
          color: #333;
          font-weight: bold;
          line-height: 20px;
        }
        .limit {
          img {
            width: 12px;
            height: 12px;
          }
          .line {
            color: #999999;
            font-family: "MicrosoftYaHei";
            font-size: 12px;
            margin: 0 0 0 10px;
            position: relative;
            top: -1px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            width: 9rem;
            display: inline-block;
          }
        }
      }
    }
  }
  .add_album_box {
    .el-dialog__body {
      padding: 20px 20px 40px;
    }
    .dialog_content {
      display: flex;
      margin: 0 30px;
      justify-content: center;

      .left_title {
        text-align: right;
        .title_text {
          width: 85px;
          margin-right: 10px;
          font-size: 16px;
          color: #666666;
          margin: 6px 10px 32px 0;
        }
        .title_text:nth-child(2) {
          margin-bottom: 58px;
        }
      }
      .right_input {
        .input_item {
          width: 258px;
          margin-bottom: 20px;
        }
        .album_description {
          width: 258px;
        }
        .album_select {
          width: 258px;
        }
      }
    }
  }
}

.icon_add_album {
  background: url("../../assets/img/photo_establish_icon.png") no-repeat;
}
.icon_small {
  display: inline-block;
  font-size: 0;
  width: 14px;
  height: 14px;
  vertical-align: middle;
}
</style>

